<div class="FondoLogin" style="min-height: 799px">
    <div class="container" ng-controller="LoginController">
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <form name="form-login">
            <div class="ContentLogin"> 
             
              <!--Campos Login-->
              <div class="col-md-12 col-sm-12 col-xs-12 CamposLogin">
                <div class="col-md-12 col-sm-12 col-xs-12 ContentLogo">
                  <img src="../../assets/images/LogoAplicativo.webp" alt="Logo">
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <input type="email" name="correo" placeholder="Correo Electronico" [(ngModel)]="correo" required>
                </div>
                <span class="col-md-12 col-sm-12 col-xs-12 error none">
                  Ingrese un correo valido.
                </span>
              <div class="col-md-12 col-sm-12 col-xs-12 BtnIngresoLogin">
                <button type="submit" class="button BtnIniciar " (click)="recover()">Enviar</button>
                <button  class="button BtnIniciar " (click)="back()">Volver</button>
              </div>
            </div>
              <!--Fin campos Login-->
            </div>
          </form>
      </div>
    </div>
  </div>
    